import * as QRCode from "qrcode";

export async function renderTotpQrDataUrl(totpUri: string): Promise<string> {
  if (!totpUri.startsWith("otpauth://totp/")) throw new TypeError("TOTP URI required");
  const dataUrl = await QRCode.toDataURL(totpUri, {
    errorCorrectionLevel: "M",
    margin: 1,
    width: 256,
  });
  if (!dataUrl.startsWith("data:image/png;base64,")) throw new TypeError("Local PNG QR output required");
  return dataUrl;
}
